import { BASE_URL } from '../config/env';

/**
 * Resolve relative URLs (like /images/..) using BASE_URL.
 * Keeps absolute http(s) and data: URLs as-is.
 */
export function resolveUrl(u, base = BASE_URL) {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (/^data:/i.test(u)) return u;
  if (/^blob:/i.test(u)) return u;

  const b = (base || '').replace(/\/+$/, '');
  const p = u.startsWith('/') ? u : `/${u}`;
  return `${b}${p}`;
}
